import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { SelectCustom } from '../../../../common/selectCustom'
import { TYPE_SELECT_VIEW_BY } from '../constant'
import { changeData, selectViewBy } from '../store/slice'

export const SelectViewBy = () => {
  const dispatch = useDispatch()

  const viewByActive = useSelector(selectViewBy)
  const chooseItem = (value) => {
    dispatch(
      changeData({
        path: ['viewBy'],
        data: value,
      }),
    )
  }

  return (
    <>
      <div className="dFlex alignItemsCenter">
        <Element style={{}}>
          <Translate value="portfolioScore.viewBy" />:
        </Element>
        <SelectCustom
          data={TYPE_SELECT_VIEW_BY}
          activeItem={viewByActive}
          isI18n
          isBorderNone
          iconNoPosition
          style={{ paddingLeft: 4, paddingRight: 0, width: 80 }}
          className="fw600 alignItemsCenter"
          chooseItem={chooseItem}
        />
      </div>
    </>
  )
}
